import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Employee } from 'src/app/models/Employees';
import { AuthService } from 'src/app/services/auth.service';
import { EmployeeSService } from 'src/app/services/modelService/employeeS.service';

@Component({
  selector: 'app-user-list-card',
  templateUrl: './user-list-card.component.html',
  styleUrls: ['./user-list-card.component.scss'],
})
export class UserListCardComponent implements OnInit {
  enlargeImage: string = null;
  @Input() theme: string = '#fEfEfE';
  @Output() mergeUser:EventEmitter<Employee> = new EventEmitter<Employee>();
  @Output() clickUserMenu:EventEmitter<Employee> = new EventEmitter<Employee>();
  @Input() emp: Employee;
  @Input() showMenu: boolean = false;

  constructor(public platform: Platform, public auth: AuthService, public empService: EmployeeSService) { }

  ngOnInit() { }

}
